// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Popup-module--wrapper--30xs6","imageWrapper":"Popup-module--imageWrapper--22U6I","right":"Popup-module--right--3ClW3","shrinktext":"Popup-module--shrinktext--UqpFq"};